import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";
import { ToastContainer } from "react-toastify";

interface BranchToolbarProps {
  showDeletedBranches: boolean;
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddClick: () => void;
}

const BranchToolbar: React.FC<BranchToolbarProps> = ({ showDeletedBranches, onCheckboxChange, onAddClick }) => (
  <div className="branch-add-container">
    <div className="branch-toolbar">
      <div className="relative" id="view-deleted-branches">
        <FormControlLabel control={<Checkbox checked={showDeletedBranches} onChange={onCheckboxChange} />} 
          label="View deleted branches" />
      </div>
        <CommonButtons className="w-44 h-10" label="ADD BRANCH" onClick={onAddClick} />
    </div>
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
  </div>
);

export default BranchToolbar;
